import { render, staticRenderFns } from "./Auth0Login.vue?vue&type=template&id=4cc8e138&scoped=true&"
import script from "./Auth0Login.vue?vue&type=script&lang=js&"
export * from "./Auth0Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc8e138",
  null
  
)

export default component.exports